import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import zeroItems from '../../assets/zeroItems_large.png';
import { useWindowSize } from '../../customHooks/useWindowSize';

const NotFoundResult = () => {
  const size = useWindowSize();

  return (
    <Grid container direction='row' justify='center' style={{ marginTop: 37 }}>
      <Grid container item xs={size.width > 600 ? 7 : 12}>
        <Grid item xs={1}>
          <FontAwesomeIcon
            icon={faInfoCircle}
            style={{
              color: '#4589FF',
              width: 32,
              height: 32
            }}
          />
        </Grid>
        <Grid item xs={11}>
          <Typography
            align='left'
            style={{
              fontFamily: 'Roboto-Light',
              fontSize: 24,
              color: '#6F6F6F',
              letterSpacing: 0,
              marginRight: size.width > 1120 ? 83 : 35,
              paddingLeft: 20
            }}
          >
            Sorry, we could not find any hash matching that name, make sure the
            information provided is a hash.
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        item
        xs={size.width > 600 ? 5 : 9}
        style={{
          marginTop: size.width > 600 ? 0 : 44
        }}
      >
        <img
          src={zeroItems}
          alt='No items found'
          style={{
            objectFit: 'contain',
            width: '100%'
          }}
        />
      </Grid>
    </Grid>
  );
};

export default NotFoundResult;
